export default __webpack_public_path__ + "static/media/047-chili pepper.a3788d87.svg";